// components/TopBar/Toggle.client.tsx
"use client";

import { useState, useEffect, useRef } from "react";

export type ToggleClientProps = {
  button: React.ReactNode;
  panel: React.ReactNode;
  defaultOpen?: boolean;
};

export default function ToggleClient({
  button,
  panel,
  defaultOpen = false,
}: ToggleClientProps) {
  const [open, setOpen] = useState(defaultOpen);
  const wrapperRef = useRef<HTMLDivElement>(null);

  // Handle click on button and nav links using event delegation
  useEffect(() => {
    const wrapper = wrapperRef.current;
    if (!wrapper) return;

    const handleClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const buttonEl = target.closest(".mobile-menu-button");
      const linkEl = target.closest(".mobile-nav a");

      if (buttonEl) {
        e.preventDefault();
        setOpen((prev) => !prev);
      } else if (linkEl) {
        setOpen(false);
      }
    };

    wrapper.addEventListener("click", handleClick);

    return () => {
      wrapper.removeEventListener("click", handleClick);
    };
  }, []);

  // Update button aria attributes and hamburger class
  useEffect(() => {
    const wrapper = wrapperRef.current;
    if (!wrapper) return;

    const buttonEl = wrapper.querySelector(".mobile-menu-button");
    const hamburgerEl = wrapper.querySelector(".hamburger");
    const navEl = wrapper.querySelector(".mobile-nav");

    if (buttonEl) {
      buttonEl.setAttribute("aria-expanded", open.toString());
      buttonEl.setAttribute(
        "aria-label",
        open ? "Chiudi menu di navigazione" : "Apri menu di navigazione"
      );
    }

    if (hamburgerEl) {
      if (open) {
        hamburgerEl.classList.add("open");
      } else {
        hamburgerEl.classList.remove("open");
      }
    }

    if (navEl) {
      if (open) {
        navEl.classList.add("open");
      } else {
        navEl.classList.remove("open");
      }
    }
  }, [open]);

  return (
    <div ref={wrapperRef}>
      {button}
      {panel}
    </div>
  );
}

